<template>
  <v-container
    fluid>
    <v-row v-if="showAddOnMessage">
      <v-col
        cols="8"
        offset="2"
        class="text-center">
        <p v-html="absenceAddOnMessage"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="8"
        offset="2"
        class="text-right"
        v-if="hideNotify == false">
        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn
              color="primary"
              dark
              rounded
              block
              v-on="on">Notify an absence</v-btn>
          </template>
          <v-card>
            <v-card-title class="">
              <span class="title">Absence Notification</span>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-row >
                <v-col cols="12">
                  <v-alert
                    :color="alertColor"
                    :value="alert"
                    class="white--text"
                    icon="check_circle">
                    {{ alertMsg }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row
                v-if="sent === false">
                <v-col cols="12">
                  <v-text-field
                    :value="this.$store.getters.pupilFullName"
                    label="Student"
                    prepend-icon="person"
                    readonly
                  />
                </v-col>
                <v-col cols="12">
                  <v-btn
                    v-if="Dbasename === 'StPatsInglewood' || Dbasename === 'TeMata' || Dbasename === 'Spotlight'"
                    color="primary"
                    rounded
                    block
                    @click="getSiblings(); hideSiblingsSelect = true">
                    Add Siblings
                  </v-btn>
                  <template
                    v-if="hideSiblingsSelect === true">
                    <v-select
                      v-model='selectOne'
                      :items="sDetails"
                      label="name"
                      multiple
                      item-text="name"
                      @change="getSiblingSelected"
                    />
                </template></v-col>
                <v-col
                  cols="12"
                  v-if="withDateRange">
                  <v-menu
                    ref="menuTwo"
                    v-model="menuTwo"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dateRangeText"
                        :label="labelText"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        hint="If date of absence is more than 1 day, please select the first and last date of absence"
                        persistent-hint
                      />

                    </template>
                    <v-date-picker
                      v-model="dateWithRange"
                      :min="minDate"
                      range>
                      <v-spacer/>
                      <v-btn
                        text
                        color="primary"
                        @click="menuTwo = false">Cancel</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menuTwo.save(dateWithRange)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col
                  cols="12"
                  v-else>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        :label="labelText"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="date"
                      :min="minDate">
                      <v-spacer/>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false">Cancel</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12">

                  <template>
                    <v-select
                      v-model="select"
                      prepend-icon="list"
                      :items="items"
                      label="Choose a default reason (required)"
                      :rules="selectRule"
                      @change="checkSelected"/>

                    <v-select
                      v-if="showTimeSelection"
                      :items="appointmentTimeArray"
                      label="Choose Time of Absence"
                      prepend-icon="timer"
                      v-model="appointmentTime"
                      @change ="checkTimeSelected"
                    />

                    <v-text-field
                      prepend-icon="mdi-clock-time-four-outline"
                      v-model="specificTime"
                      label="Time of Appointment"
                      type="time"
                      suffix="NZST"
                      v-if="showSpecificTime"
                    />

                    <v-text-field
                      prepend-icon="mdi-clock-time-four-outline"
                      v-model="expectedTime"
                      label="Expected Time of Arrival"
                      type="time"
                      suffix="NZST"
                      v-if="lateMessage"
                    />

                  </template>

                  <v-textarea
                    v-model="absenceReason"
                    prepend-icon="more_horiz"
                    label="Reason for absence (required)"
                    no-resize
                    :rules="textAreaRules"
                    placeholder="Please provide a valid reason why your student will not be attending. Please enter as much detail as possible, including the time the student will be arriving at or exiting school."
                  />

                  <!-- if another school has ask, make a config -->
                  <template v-if="Dbasename === 'UpperHutt' || Dbasename === 'Normandale'">
                    <div
                      class="pl-8"
                    >
                      <p style="color:rgb(128,128,128);">(please let the school know the illness e.g flu, cold, covid, tummy bug etc so we can monitor for possible outbreaks)</p>
                    </div>
                  </template>
                  <v-card-subtitle
                    class="pb-0 pt-0"
                    style="color:rgb(128,128,128);"><b>Note:</b> After clicking SEND, please wait for the success message before closing</v-card-subtitle>

                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer/>
              <v-btn
                color="blue darken-1"
                text
                @click="closeNotificationDialog()">Close</v-btn>
              <v-btn
                v-if="sent === false "
                color="blue darken-1"
                text
                @click="sendAbsenceNotification()">Send</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>

      <v-col
        cols="12"
        v-if="absenceData.length == 0">
        <v-alert
          :value="true"
          type="info"
          class="white--text"
          transition="scale-transition">
          There are no absent or late days recorded in {{ (new Date()).getFullYear() }} so far.
        </v-alert>
      </v-col>

      <v-col
        cols="12"
        md="10"
        offset-md="1"
        lg="8"
        offset-lg="2"
        v-if="absentPercentage!='' && Dbasename != 'MatuaNgaru'">

        <v-card>
          <v-card-text> <b>Days Absent:</b> {{ absentPercentage }}</v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="10"
        offset-md="1"
        lg="8"
        offset-lg="2"
        v-for="(dataSet, dataSetName) in absenceData"
        :key="dataSetName">
        <v-card
          class="mb-3"
          v-if="dataSet.length > 0">
          <v-card-title
            style="background-color: crimson;"
            class="white--text font-weight-bold text-uppercase subheading pb-0 pt-0">
            <v-row justify="center">
              {{ dataSetName }}
            </v-row>
          </v-card-title>
          <v-card-text class="pb-2 pt-2">
            <v-row
              justify="space-between"
              class="text-center">
              <v-col
                class="font-weight-bold"
                cols="3"
              >Date</v-col>
              <v-col
                class="font-weight-bold"
                cols="3"
              >Day</v-col>
              <v-col
                class="font-weight-bold"
                cols="3"
              >Period</v-col>
              <v-col
                class="font-weight-bold"
                cols="3"
                v-if="hideDescription!==true"
              >Description</v-col>
            </v-row>
          </v-card-text>
          <v-divider/>
          <v-card-text
            v-for="(absence, index) in dataSet"
            :key="index">
            <v-row
              justify="space-between"
              class="text-center caption">
              <v-col cols="3">{{ absence.date }}</v-col>
              <v-col cols="3">{{ absence.day }}</v-col>
              <v-col cols="3">{{ absence.dayPeriod }}</v-col>
              <v-col
                cols="3"
                v-if="hideDescription!==true">{{ absence.description }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="10"
        offset-md="1"
        lg="8"
        offset-lg="2"
      >
        <v-card
          class="mb-3"
          v-if="absenceSentRecords.length > 0">
          <v-card-title
            style="background-color: crimson;"
            class="white--text font-weight-bold text-uppercase subheading pb-0 pt-0">
            <v-row justify="center">
              Absence Sent Log
            </v-row>
          </v-card-title>
          <v-card-text class="pb-2 pt-2">
            <v-row
              justify="space-between"
              class="text-center">
              <v-col
                class="font-weight-bold"
                cols="4"
              >Time Sent</v-col>
              <v-col
                class="font-weight-bold"
                cols="4"
              >Date Of Absence</v-col>
              <v-col
                class="font-weight-bold"
                cols="4"
              >Reason of Absence</v-col>
            </v-row>
          </v-card-text>
          <v-divider/>
          <v-card-text
            v-for="(dateSentRecords, dataIndex) in absenceSentRecords"
            :key="dataIndex"
          >
            <v-row
              justify="space-between"
              class="text-center caption">
              <v-col cols="4">{{ dateSentRecords.time_sent }}</v-col>
              <v-col cols="4">{{ dateSentRecords.date_absence }}</v-col>
              <v-col cols="4">{{ dateSentRecords.reason }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
  </v-row></v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    absenceData: {},
    dialog: false,
    menu: false,
    sent: false,
    date: '',
    absenceReason: '',
    alertMsg: '',
    alertColor: '',
    hideNotify: false,
    select: '',
    items: [
      'Sick',
      'Late',
      'Medical Appointment',
      'Hospital',
      'Other'
    ],
    withDateRange: false,
    dateWithRange: [],
    menuTwo: false,
    labelText: 'Date of absence (required)',
    textAreaRules: [
      (v) => !!v || 'Please enter the reason of absence'
    ],
    absenceSentRecords: [],
    absenceAddOnMessage: '',
    showAddOnMessage: false,
    hideDescription: false,
    showTimeSelection: false,
    appointmentTime: '',
    appointmentTimeArray: ['Morning', 'Afternoon', 'Full Day', 'Specify Time'],
    showSpecificTime: false,
    specificTime: '',
    absentPercentage: '',
    hideSiblingsSelect: false,
    selectOne: '',
    sDetails: [],
    sibSelect: [],
    lateMessage: false,
    expectedTime: '',
    holdDefault: '',
    turnedOn: false,
    selectRule: [(v) => !!v || 'You must select an option from the list']
  }),

  computed: {
    ...mapState(['parentName', 'pupilId', 'Dbasename', 'userId']),
    minDate: function () {
      let now = new Date()
      return now.getFullYear() + '-' + this.pad(now.getMonth() + 1) + '-' + this.pad(now.getDate())
    },
    console: function () {
      return console
    },
    alert: function () {
      if (this.alertMsg !== '') {
        return true
      } else {
        return false
      }
    },
    getNameSelected () {
      const el = this.carriers.find(e => e.id === this.product.carrier_id)

      if (el) {
        return el.name
      }
    },
    dateRangeText () {
      if (this.dateWithRange.length !== 0) {
        return this.dateWithRange.join(' ~ ')
      }
    }
  },
  onIdle () {
    if (this.$store.state.withPin && this.$store.state.withPin === true) {
      this.$router.push({ path: '/pin', replace: true })
    }
  },
  methods: {
    getSiblings: function () {
      this.$http.get('siblingsV2/' + this.Dbasename + '/' + this.pupilId + '/' + this.userId)
        .then(resp => {
          for (let i = 0; i < (resp.data).length; i++) {
            this.sDetails.push({
              id: resp.data[i].id,
              name: resp.data[i].PerferredName + ' ' + resp.data[i].PerferredSname
            })
          }
        })
    },
    pad: function (number) {
      if (number < 10) {
        return '0' + number
      }
      return number
    },
    checkTimeSelected: function () {
      var timeSelected = this.appointmentTime
      if (timeSelected.includes('Specify Time')) {
        this.showSpecificTime = true
      } else {
        this.showSpecificTime = false
      }
    },
    checkSelected () {
      const selectedOption = this.select
      this.absenceReason = selectedOption
      this.showTimeSelection = false
      this.showSpecificTime = false
      this.lateMessage = false
      this.appointmentTime = ''
      this.holdDefault = ''

      if (selectedOption.includes('Other')) {
      } else if (selectedOption.includes('Medical Appointment')) {
        this.showTimeSelection = true
        this.holdDefault = selectedOption
      } else if (selectedOption.includes('Late')) {
        this.lateMessage = true
        this.showSpecificTime = false
        this.holdDefault = selectedOption
      }
    },
    getSiblingSelected: function () {
      let tempSelect = this.selectOne.toString()
      this.sibSelect = []
      if (tempSelect.includes(',')) {
        let tempArr = tempSelect.split(',')
        for (let i = 0; i < tempArr.length; i++) {
          for (let j = 0; j < this.sDetails.length; j++) {
            if (tempArr[i] === this.sDetails[j].name) {
              if (!this.sibSelect.includes(this.sDetails[j].id)) {
                this.sibSelect.push(this.sDetails[j].id)
              }
            }
          }
        }
      } else {
        for (let i = 0; i < this.sDetails.length; i++) {
          if (tempSelect === this.sDetails[i].name) {
            this.sibSelect.push(this.sDetails[i].id)
          }
        }
      }
    },
    saveLog: async function (dateUsed) {
      var timeAppointment = ''
      var absenceReason = ''
      if (this.showTimeSelection) {
        timeAppointment = this.appointmentTime
      }

      if (timeAppointment.includes('Specify Time') && this.showSpecificTime === true) {
        timeAppointment = this.specificTime
      }
      if (this.holdDefault.includes('Medical Appointment') && timeAppointment === '') {
        this.alertMsg = 'Please fill the time of absence'
        this.alertColor = 'error'
        this.hideNotify = false
        return
      }

      if (this.holdDefault.includes('Late') && this.expectedTime === '') {
        this.alertMsg = 'Please fill expected time of arrival'
        this.alertColor = 'error'
        this.hideNotify = false
        return
      } else {
        if (this.expectedTime !== '') {
          absenceReason = this.absenceReason + ' - ' + 'Expected Time of Arrival: ' + this.expectedTime
        } else {
          absenceReason = this.absenceReason
        }
      }

      await this.checkCompSetting()
      if (this.turnedOn === true && this.absenceReason.trim().toLowerCase() === 'sick') {
        this.alertMsg = `Please provide additional details for the "${this.absenceReason}" option`
        this.alertColor = 'error'
        this.hideNotify = false
        return
      }

      if (this.absenceReason.trim().toLowerCase() === 'other') {
        this.alertMsg = `Please provide additional details for the "${this.absenceReason}" option`
        this.alertColor = 'error'
        this.hideNotify = false
        return
      }

      this.$http.post('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/newSaveAbsenceLogV2', {
        dateAbsent: dateUsed,
        absenceReason: absenceReason,
        timeAppointment: timeAppointment,
        siblingsIds: this.sibSelect
      })
        .then(resp => {
        })
    },
    getAbsenceSentRecords: function () {
      this.$http.get('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/' + this.userId + '/absenceRecordsV2')
        .then(resp => {
          this.absenceSentRecords = resp.data.absenceRecordsArray
        })
    },
    sendAbsenceNotification: async function () {
      var timeAppointment = ''
      var absenceReason = ''
      if (this.showTimeSelection) {
        timeAppointment = this.appointmentTime
      }

      if (timeAppointment.includes('Specify Time') && this.showSpecificTime === true) {
        timeAppointment = this.specificTime
      }

      if (this.select === null || this.select === '') {
        this.alertMsg = 'Please select a default reason'
        this.alertColor = 'error'
        this.hideNotify = false
        return
      }

      if (this.holdDefault.includes('Medical Appointment') && timeAppointment === '') {
        this.alertMsg = 'Please choose the time of absence'
        this.alertColor = 'error'
        this.hideNotify = false
        return
      }
      if (this.holdDefault.includes('Late') && this.expectedTime === '') {
        this.alertMsg = 'Please fill expected time of arrival'
        this.alertColor = 'error'
        this.hideNotify = false
        return
      } else {
        if (this.expectedTime !== '') {
          absenceReason = this.absenceReason + ' - ' + 'Expected Time of Arrival: ' + this.expectedTime
        } else {
          absenceReason = this.absenceReason
        }
      }

      await this.checkCompSetting()
      if (this.turnedOn === true && this.absenceReason.trim().toLowerCase() === 'sick') {
        this.alertMsg = `Please provide additional details for the "${this.absenceReason}" option`
        this.alertColor = 'error'
        this.hideNotify = false
        return
      }

      if (this.absenceReason.trim().toLowerCase() === 'other') {
        this.alertMsg = `Please provide additional details for the "${this.absenceReason}" option`
        this.alertColor = 'error'
        this.hideNotify = false
        return
      }

      if (this.withDateRange) {
        if (this.dateWithRange.length !== 0 && this.dateWithRange.length !== 2 && this.absenceReason !== '') {
          this.$http.post('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/' + this.userId + '/notifyAbsenceV2', {
            dateAbsent: this.dateWithRange,
            absenceReason: absenceReason,
            timeAppointment: timeAppointment,
            siblingsIds: this.sibSelect
          })
            .then(resp => {
              this.$store.commit('loading', true)

              if (resp.data.includes('Sent:') && resp.status === 200) {
                // this.dialog = false
                this.saveLog(this.dateWithRange)
                this.getAbsenceSentRecords()
                this.dateWithRange = []
                this.absenceReason = ''
                this.holdDefault = ''
                this.alertColor = 'success'
                this.alertMsg = 'Absence notification sent successfully.'
                this.sent = true
                this.$store.commit('loading', false)
                setTimeout(() => {
                  location.reload()
                }, 5000)
              } else {
                this.alertColor = 'error'
                this.alertMsg = 'An error occurred sending absence notification, please try again.'
                this.$store.commit('loading', false)
              }
            })
        } else if (this.dateWithRange.length === 2 && this.absenceReason !== '') {
          var dateTest = this.dateWithRange
          var date1 = new Date(dateTest[0])
          var date2 = new Date(dateTest[1])
          // console.log(date1 > date2)
          if (date1 > date2) {
            this.alertColor = 'error'
            this.alertMsg = 'Start date should not be greater than the end date'
            this.dateWithRange = []
          } else {
            this.$http.post('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/' + this.userId + '/notifyAbsenceV2', {
              dateAbsent: this.dateWithRange,
              absenceReason: absenceReason,
              timeAppointment: timeAppointment,
              siblingsIds: this.sibSelect
            })
              .then(resp => {
                this.$store.commit('loading', true)

                if (resp.data.includes('Sent:') && resp.status === 200) {
                  // this.dialog = false
                  this.saveLog(this.dateWithRange)
                  this.getAbsenceSentRecords()

                  this.absenceReason = ''
                  this.holdDefault = ''
                  this.dateWithRange = []

                  this.alertColor = 'success'
                  this.alertMsg = 'Absence notification sent successfully.'
                  this.sent = true
                  this.$store.commit('loading', false)
                  setTimeout(() => {
                    location.reload()
                  }, 5000)
                } else {
                  this.alertColor = 'error'
                  this.alertMsg = 'An error occurred sending absence notification, please try again.'
                  this.$store.commit('loading', false)
                }
              })
          }
        } else {
          this.alertColor = 'error'
          this.alertMsg = 'Please fill in all the required fields.'
        }
      } else {
        if (this.date !== '' && this.absenceReason !== '') {
          this.$http.post('pupilsV2/' + this.Dbasename + '/' + this.pupilId + '/' + this.userId + '/notifyAbsenceV2', {
            dateAbsent: this.date,
            absenceReason: absenceReason,
            timeAppointment: timeAppointment,
            siblingsIds: this.sibSelect
          })
            .then(resp => {
              this.$store.commit('loading', true)

              if (resp.data.includes('Sent:') && resp.status === 200) {
                this.saveLog(this.date)
                this.getAbsenceSentRecords()

                this.date = ''
                this.absenceReason = ''
                this.holdDefault = ''
                this.alertColor = 'success'
                this.alertMsg = 'Absence notification sent successfully.'
                this.sent = true
                this.$store.commit('loading', false)
                setTimeout(() => {
                  location.reload()
                }, 5000)
              } else {
                this.alertColor = 'error'
                this.alertMsg = 'An error occurred sending absence notification, please try again.'
                this.$store.commit('loading', false)
              }
            })
        } else {
          this.alertColor = 'error'
          this.alertMsg = 'Please fill in all the required fields.'
        }
      }
    },
    async checkCompSetting () {
      const getCompSetting = await this.$http.get('pupilsV2/' + this.Dbasename + '/checkCompSettingV2')
      this.turnedOn = getCompSetting.data.turnedOn
    },
    closeNotificationDialog: function () {
      this.dialog = false
      this.sent = false
      this.alertMsg = ''
      this.alertColor = ''
      this.absenceReason = ''
      this.select = ''
      this.dateWithRange = []
      this.date = ''
      this.appointmentTime = ''
      this.specificTime = ''
      this.expectedTime = ''
      this.holdDefault = ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)

      vm.$http.get('withDateRangeV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          vm.withDateRange = resp.data.withRange
        })

      vm.$http.get('absenceAddOnV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          vm.absenceAddOnMessage = resp.data.absenceAddOnMessage
          vm.showAddOnMessage = resp.data.showAddOnMessage
        })

      if (vm.$store.state.Dbasename === 'Ngaio') {
        vm.labelText = 'Date/period of absence (required)'
      }

      vm.$http.get('presetReasonV2/' + vm.$store.state.Dbasename)
        .then(resp => {
          if (resp.data.length !== 0) {
            vm.items = resp.data
          }
        })

      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/' + vm.$store.state.userId + '/absenceRecordsV2')
        .then(resp => {
          vm.absenceSentRecords = resp.data.absenceRecordsArray
        })

      vm.$http.get('pupilsV2/' + vm.$store.state.Dbasename + '/' + vm.$store.state.pupilId + '/absencesV2')
        .then(resp => {
          vm.absenceData = resp.data.absenceData
          vm.hideNotify = resp.data.hide_Notify
          vm.hideDescription = resp.data.hide_description
          vm.absentPercentage = resp.data.absentPercentage
          vm.$store.commit('loading', false)
        })
    })
  }
}
</script>
<style>
.v-date-picker-title__date {
  display: none;
}
</style>
